import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PageLeavingPopLoadingState {
    isUnSavedChanges: boolean;
}

const initialState: PageLeavingPopLoadingState = {
    isUnSavedChanges: false,
};

const UnSavedChangesSlice = createSlice({
    name: 'unsavedChanges',
    initialState,
    reducers: {
        setUnSavedChanges: (state, action: PayloadAction<boolean>) => {
            state.isUnSavedChanges = action.payload;
        },

    },
});

export const {setUnSavedChanges } = UnSavedChangesSlice.actions;
export default UnSavedChangesSlice.reducer;